import * as render from './render.pug'
import { localtime } from '~core/dist/utils/time/localtime.js'

export const NotificationListItemLayout = {
  ...render,
  props: {
    notification: {
      type: Object
    }
  },
  emits: [],
  components: {},
  directives: {},
  setup (props, { emit }) {
    return {
      localtime
    }
  }
}
